import {useParams} from "react-router-dom";
import {useEffect, useState} from "react";
import {Beneficiary, ICampaign, ICampaignTeam, ICurrencyRates, IDonation} from "../types";
import {
   // Accordion,
    ActionIcon,
    Anchor,
    Avatar,
    Box,
    Button,
    Card,
    Container,
    Divider,
    Flex,
    Grid,
    Group,
    Loader,
    Paper,
    PaperProps,
    Progress,
    Stack,
    Text,
    TextProps,
    Title,
    TitleProps,
    UnstyledButton
} from "@mantine/core";
import {IconFlag, IconHeart, IconHeartFilled, IconSeparator, IconShare} from "@tabler/icons-react";
import {useDisclosure, useMediaQuery, useToggle} from "@mantine/hooks";
import {BackButton, DonationDrawer,  NotFound, ShareModal, UserCard} from "../components";
import {Helmet} from "react-helmet-async";
import dayjs from 'dayjs';
import LocalizedFormat from 'dayjs/plugin/localizedFormat';
import {notifications} from "@mantine/notifications";
import { convertCurrency, isErrorObject, toTitleCase } from "../utils/utils";
import { makeGetRequest, makePostRequest } from "../services/httpHelper";
import ErrorHandler from "../services/ErrorHandler";
import { formatCurrency } from "../utils/FormValidator";
import { Link } from "react-router-dom";
import CampaignDonorsTable from "../components/CampaignDonorsTable";
import CampaignTeamTable from "../components/CampaignTeamTable";
import SocialShare from "../components/SocialShare";
//import { IMAGE_BASE_URL } from "../services/paths";
import ErrorBoundary from "../utils/ErrorBoundary";
import CampaignBeneficiary from "./CampaignBeneficiary";
import VideoPlayerModal from "./VideoPlayerModal";
import SanitizeHtmlComponent from "./SanitizeHtmlComponent";

const CampaignDetailsPage = (): JSX.Element => {
    dayjs.extend(LocalizedFormat)
    const {id} = useParams();
    const [campaign, setCampaign] = useState<ICampaign>();
    const [beneficiary, setBeneficiary] = useState<Beneficiary|null>();
    const [opened, {open, close}] = useDisclosure(false);
    const [donateOpened, {open: donateOpen, close: donateClose}] = useDisclosure(false);
    const [following, setFollowing] = useToggle();
    const matchesMobile = useMediaQuery('(max-width: 768px)');
    const [error, setError] = useState<string | null>(null);
    const [isLoading, setIsLoading] = useState(false);
    const [donations, setDonations] = useState<IDonation[]>([]);
    const[totalFollowers,setTotalFollowers] = useState(0)
    const [teams, setTeams] = useState<ICampaignTeam[]>([]);
    const [userCurrencyCode, setUserCurrencyCode] = useState("USD");
    const [exchangeRates, setExchangeRates] = useState<ICurrencyRates>();

    


//const campaignImage = IMAGE_BASE_URL+campaign?.image;
 



    const getProgress =(raised:number,target:number):number=>{
        let progress = 0;
        if(userCurrencyCode===campaign?.currency){
             progress = (raised/target)*100;

            
        }else{
           const convertRaised = handleCurrencyConversion(raised,campaign?.currency||'','USD');
           const convertTarget = handleCurrencyConversion(target,campaign?.currency||'','USD');
           if(convertRaised?.amount && convertTarget?.amount){
            progress =(convertRaised?.amount/convertTarget?.amount)*100


           }

        }
       
    
        return progress;
    
    }

    const paperProps: PaperProps = {
        p: "md",
        shadow: "sm",
    }

    const titleProps: TitleProps = {
        size: 32,
        weight: 700,
        transform: 'capitalize',
        sx: {lineHeight: '40px'}
    }

    const subTitleProps: TextProps = {
        size: 20,
        weight: 600,
        sx: {lineHeight: '28px'}
    }

    const iconSize = 18;
    {}

    const followCampaign = async () => {
        const user = JSON.parse(localStorage.getItem('user') || '{}');

        const data = {
            user_id: user.id,
            campaign_id: id,
        }
        const res = await makePostRequest('follow-campaign', data);

        if (res && res.errorType) {
            setError(res.errorMessage)
        } else {
           
            //setFollowing()    
            setFollowing(!following)    

}
    }

    const fetchCampaignBeneficiary = async () => {
        setIsLoading(true);
        const endpoint =`campaign-beneficiary/${id}`;
        const res = await makeGetRequest(endpoint);
        if (isErrorObject(res)) {
            setIsLoading(false);
            const errorMessage = ErrorHandler(res);
            //setError(errorMessage);
            console.log(errorMessage)
            setError('Failed to process beneficiary data')
        } else {
            setBeneficiary(res.data);
            setIsLoading(false);

        }
    };

    // Fetch exchange rates
    const fetchExchangeRates = async () => {
        const endpoint = "latest-currency-exchange-rates";
        const res = await makeGetRequest(endpoint);
        if (isErrorObject(res)) {
            const errorMessage = ErrorHandler(res);
            setError(errorMessage);
        } else {
            setExchangeRates(res.data);
        }
    };

    const fetchUserLocation = async () => {
        try {
          const response = await fetch("https://ipapi.co/json/");
          const locationData = await response.json();
          const userCurrency = locationData.currency || campaign?.currency;
          setUserCurrencyCode(userCurrency.toUpperCase());
        } catch (err) {
          console.error("Failed to get user location:", err);
          setUserCurrencyCode("USD");
        }
      };


    const totalRaised = ():number=>{
        let total =0;
        const campaignDonations = donations && donations.filter((donation)=>donation.campaign_id===id);
        campaignDonations && campaignDonations.map((d)=>{
            if(campaign?.currency === d.donation_currency){
                //proceed in local currency
                total += parseFloat(d.donation_amount);
            }else{
                //calculate total raised amount in USD for global display
                const amountInUsd = handleCurrencyConversion(parseFloat(d.donation_amount),d.donation_currency||'',campaign?.currency||'')

                total += amountInUsd?.amount||0;
            }
            
        })

        return total;
    }

        useEffect(() => {
            const fetchCampaign = async () => {
                setIsLoading(true);
                const res = await makeGetRequest( `campaign/${id}`);
                if (isErrorObject(res)) {
                    setIsLoading(false);
                    const errorMessage = ErrorHandler(res);
                    setError(errorMessage);
                  } else {
                    setCampaign(res.data);

                    setTotalFollowers(res.data.campaignfollowers.length)
                }
                setIsLoading(false);
            };

            const fetchDonations = async () => {
                setIsLoading(true);
                const endpoint =`campaign-donors/${id}`;
                const res = await makeGetRequest(endpoint);
                if (isErrorObject(res)) {
                    setIsLoading(false);
                    const errorMessage = ErrorHandler(res);
                    setError(errorMessage);
                } else {
                    setDonations(res.data);
                    setIsLoading(false);
    
                }
            };


            const campaignPromoters = async () => {
                setIsLoading(true);
                const endpoint =`campaign-team/${id}`;
                const res = await makeGetRequest(endpoint);
                if (isErrorObject(res)) {
                    setIsLoading(false);
                    const errorMessage = ErrorHandler(res);
                    setError(errorMessage);
                } else {
                    setTeams(res.data);
                    setIsLoading(false);
    
                }
            };
           fetchCampaign();
           fetchDonations();
           campaignPromoters();
           fetchCampaignBeneficiary();
           fetchExchangeRates();
           fetchUserLocation();
        }, [id]);

         // Currency conversion handler
            const handleCurrencyConversion = (amount: number, fromCurrency: string, toCurrency: string) => {
                return convertCurrency(amount, fromCurrency, toCurrency, exchangeRates?.rates || {});
            };


        const totalRaisedInUsd = handleCurrencyConversion(totalRaised(), campaign?.currency||'KES', "USD");
        const targetAmountInUsd = handleCurrencyConversion(campaign?.target||0, campaign?.currency||'KES', "USD");


    

    return (
        <>
        <ErrorBoundary>

       
        {isLoading && <Loader/>}
        {error && <p className="error">{error}</p>}
            <Helmet>
                <title>{campaign?.title}</title>
            </Helmet>
            <Box>
                {campaign ? <Container size="lg">
                    <BackButton mb="md"/>
                    <Grid>
                        <Grid.Col lg={8}>
                            <Stack>
                                <Card padding="md" shadow="sm">
                                    <Card.Section>
                                  
                                         <img crossOrigin="anonymous" src={`${campaign.image}`} height={480}/>
                                    </Card.Section>
                                    <Stack mt="md">
                                        {!matchesMobile ?
                                            <Flex gap="xs" align="center">
                                                <Text size="sm">Campaign created by</Text>
                                                <UnstyledButton component={Anchor}>
                                                    <Flex gap="xs" align="center">
                                                        <Avatar src={campaign?.image} radius="xl" size="sm"/>
                                                        <Text size="sm">{campaign?.fundRaiser.first_name} {campaign?.fundRaiser.last_name}</Text>
                                                    </Flex>
                                                </UnstyledButton>
                                                <IconSeparator size={18}/>
                                                <Text component={Anchor} size="sm">{campaign?.country}</Text>
                                                <IconSeparator size={18}/>
                                                <Text component={Anchor} size="sm">{campaign && toTitleCase(campaign.category.category)}</Text>
                                            </Flex> :
                                            <Stack>
                                                <Flex gap="md">
                                                    <Text size="sm">Fundraise campaign created by</Text>
                                                    <UnstyledButton component={Anchor}>
                                                        <Flex gap="xs" align="center">
                                                            <Avatar src={campaign.fundRaiser?.avatar } radius="xl"
                                                                    size="sm"/>
                                                            <Text size="sm">{campaign?.fundRaiser.first_name} {campaign?.fundRaiser.last_name}</Text>
                                                            
                                                        </Flex>
                                                    </UnstyledButton>
                                                </Flex>
                                                <Group>
                                                    <Text size="sm">Location
                                                        - <Anchor>{toTitleCase(campaign?.country)}</Anchor></Text>
                                                    <Text size="sm">Category
                                                        - <Anchor>{toTitleCase(campaign?.category.category)}</Anchor></Text>
                                                                                                                                                                </Group>
                                                
                                            </Stack>
                                        }
                                        <Text {...subTitleProps}>Our story</Text>
                                        {/*<Text size="sm">{campaign?.description}</Text>*/}
                                      <SanitizeHtmlComponent htmlContent={campaign?.description}/>
                                        {beneficiary && <CampaignBeneficiary beneficiary={beneficiary} />}

                                      {campaign.video && <VideoPlayerModal videoUrl={campaign.video} />}
                                        {matchesMobile && <>
                                            <Divider/>
                                            <Flex align="flex-end" gap="sm">
                                                {
                                                userCurrencyCode===campaign.currency ?
                                                <Title {...titleProps} align="center">{campaign.currency}{totalRaised().toFixed(2)}<small>(USD ${totalRaisedInUsd?.amount})</small></Title>
                                                :
                                                <Title {...titleProps} align="center">{totalRaisedInUsd?.amount}</Title>
                                                }
                                               
                                                <Text fw={500} align="center" color="dimmed">raised
                                                    of {formatCurrency(parseFloat(campaign?.target.toString()))}</Text>
                                            </Flex>
                                            <Progress value={7} size="md"/>
                                            <Flex justify="space-between">
                                                <Text fw={500}>{getProgress(parseInt(totalRaised().toString()),parseFloat(campaign.target.toString())).toFixed(2)}% Funded</Text>
                                                <Text fw={500}>{donations.length} Donations</Text>
                                            </Flex>
                                            <Flex align="center" gap="xs">
                                                <Button onClick={donateOpen} fullWidth>Donate</Button>
                                                <ActionIcon
                                                    variant="subtle"
                                                    onClick={open}
                                                    color="blue"
                                                    title="Share with your friends"
                                                    size="lg"
                                                >
                                                    <IconShare size={iconSize}/>
                                                </ActionIcon>
                                                <ActionIcon
                                                    title={`${following ? 'Unfollow' : 'Follow'} this campaign`}
                                                    // variant={following ? 'filled' : 'subtle'}
                                                    size="lg"
                                                    color={'secondary'}
                                                    onClick={() => {
                                                        followCampaign();
                                                        notifications.show({
                                                            title: 'Notification',
                                                            message: `${following ? 'Following' : 'Unfollowed'} this campaign`,
                                                            withBorder: true,
                                                            styles: (theme) => ({
                                                                root: {
                                                                    backgroundColor: theme.colors.blue[6],
                                                                    borderColor: theme.colors.blue[6],

                                                                    '&::before': {backgroundColor: theme.white},
                                                                },

                                                                title: {color: theme.white},
                                                                description: {color: theme.white},
                                                                closeButton: {
                                                                    color: theme.white,
                                                                    '&:hover': {backgroundColor: theme.colors.blue[7]},
                                                                },
                                                            }),
                                                        })
                                                    }}
                                                >
                                                    {following ?
                                                        <IconHeartFilled size={iconSize}/> :
                                                        <IconHeart size={iconSize}/>
                                                    }
                                                </ActionIcon>
                                            </Flex>
                                        </>}
                                    </Stack>
                                </Card>
                                <Paper {...paperProps}>
                                    <Text {...subTitleProps} mb="sm">Organizer</Text>
                                    <UserCard campaignId={id ?? ''} />

                                </Paper>


                                <Paper {...paperProps}>
                                <Text>
        Created on {campaign?.createdAt ? dayjs(campaign.createdAt).isValid() ? dayjs(campaign.createdAt).format('LL') : 'Invalid date' : 'Date not available'}
    </Text>
                                </Paper>
                                <Paper {...paperProps}>
                                <Text>Followers {totalFollowers}</Text>                                
                                </Paper>

                                
                                    
                               
                                <Paper {...paperProps}>
                                    <Text {...subTitleProps} mb="sm">Promoters</Text>
                                    <CampaignTeamTable teams={teams}/>
                                </Paper>



                                {!matchesMobile &&
                                   <Link to="/contact-us">
                                    <Button
                                        leftIcon={<IconFlag size={iconSize}/>}
                                        variant="subtle"
                                        color="secondary"
                                    >
                                        Report campaign
                                    </Button>
                                   </Link>
                                }


                        <SocialShare
                        title={campaign?.title || "Support this campaign"}
                        caption={campaign?.description?.split(" ").slice(0, 30).join(" ") + "..."}
                        image={campaign.image}
                        link={window.location.href}
                        />

                            </Stack>
                        </Grid.Col>
                        <Grid.Col lg={4}>
                            <Stack>
                                {!matchesMobile &&
                                    <Paper {...paperProps}>
                                        <Stack spacing="sm">
                                            {
                                                userCurrencyCode===campaign.currency ?
                                                <>
                                                 <Title {...titleProps} align="center">{campaign.currency==='usd'?'$':campaign.currency}{formatCurrency(parseFloat(totalRaised().toString()))}</Title>
                                            <Text fw={500} align="center" color="dimmed">raised
                                                of {campaign?.target}</Text>
                                                </>
                                                :
                                                <>
                                                 <Title {...titleProps} align="center">{totalRaisedInUsd?.toCurrency}{totalRaisedInUsd?.amount.toFixed(2)}</Title>
                                            <Text fw={500} align="center" color="dimmed">raised
                                                of {targetAmountInUsd?.amount.toFixed(2)}</Text>
                                                </>
                                            }
                                           
                                            <Progress value={7} size="md"/>
                                            <Flex justify="space-between">
                                                <Text fw={500}>{getProgress(parseFloat(totalRaised().toString()),parseFloat(campaign.target.toString())).toFixed(2)}% Funded</Text>
                                                <Text fw={500}>{campaign?.donations.length} Donations</Text>
                                            </Flex>
                                            <Button size="xl" onClick={donateOpen}>Donate</Button>
                                            <Button
                                                leftIcon={<IconShare size={iconSize}/>}
                                                variant="outline"
                                                onClick={open}
                                                color="blue"
                                            >
                                                Share with friends
                                            </Button>
                                            <Button
                                                leftIcon={following ? <IconHeartFilled size={iconSize}/> :
                                                    <IconHeart size={iconSize}/>}
                                                variant={following ? 'filled' : 'subtle'}
                                                color="secondary"
                                                onClick={() => {
                                                    followCampaign();
                                                    notifications.show({
                                                        title: 'Notification',
                                                        message: `${following ? 'Following' : 'Unfollowed'} this campaign`,
                                                        withBorder: true,
                                                        styles: (theme) => ({
                                                            root: {
                                                                backgroundColor: theme.colors.blue[6],
                                                                borderColor: theme.colors.blue[6],

                                                                '&::before': {backgroundColor: theme.white},
                                                            },

                                                            title: {color: theme.white},
                                                            description: {color: theme.white},
                                                            closeButton: {
                                                                color: theme.white,
                                                                '&:hover': {backgroundColor: theme.colors.blue[7]},
                                                            },
                                                        }),
                                                    })
                                                }}
                                            >
                                                {following ? 'Unfollow' : 'Follow'} this campaign
                                            </Button>
                                        </Stack>
                                    </Paper>
                                }
                              
                                <Paper>
                                <Text {...subTitleProps}>Donors</Text>
                                    <CampaignDonorsTable donations={campaign?.donations} campaign_currency={campaign.currency}/>
                                </Paper>
                                {matchesMobile &&
                                    <Button
                                        leftIcon={<IconFlag size={iconSize}/>}
                                        variant="subtle"
                                        color="secondary"
                                    >
                                        Report campaign
                                    </Button>
                                }
                            </Stack>
                        </Grid.Col>
                    </Grid>
                </Container> : <NotFound/>}
                <ShareModal opened={opened} onClose={close} campaign={campaign} iconSize={iconSize}/>
                <DonationDrawer campaign={campaign} opened={donateOpened} onClose={donateClose} iconSize={iconSize}/>
            </Box>
            </ErrorBoundary>
        </>
    );
};

export default CampaignDetailsPage;
